import { render, staticRenderFns } from "./ministries.vue?vue&type=template&id=1b3fbdde"
import script from "./ministries.vue?vue&type=script&lang=js"
export * from "./ministries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports